import React, { useContext, useState } from "react";
import styled from "styled-components";
import {
  gasEstimateMatic,
  maticSendToken,
} from "../../Pages/Farm/contractData";
import { gasEstimate, sendToken } from "../../config/provider";
import { ethers } from "ethers";
import CircularLoader from "../CircularLoader/CircularLoader";
import { makeStyles } from "@mui/styles";
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
} from "@mui/material";
import { useNavigate } from "react-router-dom";

// import { Manager } from "socket.io-client";
import axios from "axios";
import { gasEstimateMaticTransfer } from "../../config/gasEstimation";
import environmentVariables from "../../config/environmentVariables";
import { userInfoContext } from "../../context/userInfoContext";
const SuccessIcon = `${environmentVariables?.cdnUrl}successicon.png`
// const manager = new Manager(`${environmentVariables?.apiUrl}`);
// const socket = manager.socket("/");
const { parseUnits } = ethers;
const ethereumAddressRegex = /^0x[a-fA-F0-9]{40}$/;
const Root = styled.div``;
const Container = styled.div`
  @media (max-width: 768px) {
    /* padding: 0 15px; */
    // width: 100%;
    // display:flex;
    // justify-content: center;
    // align-items: center;
    // text-align: center;
  }
`;
const useStyles = makeStyles((theme) => ({
  customButton: {
    padding: "50px",
    backgroundColor: "#2a2a2a",
    border: "1px solid #484848",
    borderRadius: "10px",
    color: "#fff",
    minWidth: "360px",
    width: "580px",
    "@media (max-width: 768px)": {
      minWidth: "360px",
    },
    "@media (max-width: 600px)": {
      maxWidth: "220px",
      minWidth: "350px",
      padding: "40px 30px",
      backgroundColortransparent: true,
    },
    "@media (max-width: 400px)": {
      maxWidth: "220px",
      minWidth: "320px",
      padding: "40px 30px",
      backgroundColortransparent: true,
    },
  },
}));
const AddressWrapper = styled.div`
  margin: 1rem 0;
  position: relative;
  @media (max-height: 480px) {
    width: 100%;
  }

`;

const Fortwoinputslandscape = styled.div`
  display: block;
  @media (max-height: 480px) {
    display: flex;
    gap: 20px;
  }
`;
const Inputwidthlandscape = styled.div`
    
  @media (max-height: 480px) {
    width: 100%;
  }
`;

const ErrorMsg = styled.div`
  color: red;
  position: absolute;
`;
const TextWrapper = styled.div``;
const Text = styled.div`
  font-size: 18px;
  font-family: "SweraDemo";
  padding: 14px 0 10px;
  flex: 1;
  min-width: 0;
  font-family: inherit;
  font-weight: 700;
  text-align: left;
  color: #b9b9b9;
`;

const InputWrapper = styled.div`
  width: 100%;
  font-size: 18px;
  background: rgba(40, 43, 47, 0.8);
  outline: none;
  border: none;
  font-weight: 400;
  text-align: left;
  color: #75787b;
  line-height: 16px;
  // padding: 2px 0px 0px 20px;
  border-radius: 10px;
  border: none;
  position: relative;
  input {
    &::placeholder {
      color: #757575;
      font-size: 16px;
    }
  }
`;
const Input = styled.text``;
// const FeeTextWrapper = styled.div`
//   display: flex;
//   justify-content: space-between;
//   padding: 5px 0;
// `;
const FeeText = styled.text`
  font-size: 20px;
  font-weight: 500;
  color: #75787b;
`;

const ButtonWrapper = styled.div`
  padding: 5px 0 5px 0;
  margin-top: 45px;
  @media (max-height: 480px) {
    margin-top: 10px;
  }
`;
const Button = styled.button`
  background: rgb(31 92 106);
  box-shadow: 0 4px 20px 0 rgba(0, 0, 0, 0.06);
  border: none;
  font-weight: 700;
  text-align: center;
  color: #fff;
  margin: 0 auto;
  display: block;
  border-radius: 10px;
  padding: 15px 50px;
  font-size: 18px;
  // cursor: pointer;
  cursor: ${(p) => (p.disabled ? "not-allowed" : "pointer")};
  width: 100%;
`;

const DialogStyledUpdate = styled(Dialog)``;
const ButtonCancel = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  position: absolute;
  top: -15px;
  right: -20px;
  background-color: #b3b3b3;
  border-radius: 50px;
  outline: none;
  border: none;
  font-size: 20px;
  /* font-weight: 600; */
  padding: 20px;
  margin: 0;
  cursor: pointer;
  color: #000;
  width: 45px;
  height: 45px;
  transition: 1s;
  @media (max-width: 768px) {
    margin: 5px 0;
    top: -25px;
    right: -15px;
  }
  @media (max-width: 600px) {
    top: -25px;
    right: -15px;
  }

  /* &:hover {
    background: linear-gradient(45deg, #fff, #d3d3d3);
    color: #151a1c;
  } */
`;

const NftNameConfirm = styled.div`
  display: flex;
  align-items: center;
  padding-bottom: 20px;
  padding-top: 20px;
  border-bottom: 1px solid #484848;
  border-top: 1px solid #484848;
  justify-content: space-between;
`;
const NftConfirmImg = styled.img`
  width: 60px;
  height: 60px;
  background-color: #fff;
  border-radius: 10px;
`;

const NameandcategoriesWrapper = styled.div`
  /* margin: 0 0 0 20px; */
`;
const NftNameConfirmHead = styled.div`
  font-size: 26px;
  font-weight: 600;
  ${(p) =>
    p.GasFeeText &&
    `
  font-size:24px;
  `}
`;

const NftNameConfirmSubHead = styled.div`
  font-size: 16px;
  color: #bbb;
  text-transform: capitalize;
`;

const NftNameConfirmHash = styled.div`
  background: -webkit-linear-gradient(0deg, #facf49, #fb7111);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  font-size: 18px;
  font-weight: 800;
  background: -webkit-linear-gradient(0deg, #facf49, #fb7111);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  color: #c95e73;
  text-transform: uppercase;
  background-color: #171e22;
  padding: 5px 20px;
  border-radius: 50px;
  position: relative;
  margin-bottom: 10px;
  margin-left: 10px;
  border: 1px solid #31393c;
  display: flex;
  align-items: center;
  max-height: 35px;
  justify-content: space-between;
  width: 105px;
`;

const NftAmountConfirm = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 30px 0 0;
`;
const NftAmountConfirmHead = styled.div`
  font-size: 24px;
`;
const NftAmountConfirmSubHead = styled.div`
  font-size: 24px;
`;
const NftAmountConfirmHeadPur = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 10px 0;
  @media (max-width: 600px) {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
  }
`;
const NftAmountConfirmHead2 = styled.div`
  font-size: 16px;
  color: #bbb;
  @media (max-width: 600px) {
    // font-size: 20px;
    margin-bottom: 3px;
  }
`;
const NftAmountConfirmSubHead2 = styled.div`
  font-size: 16px;
  display: flex;
  color: #bbb;
  @media (max-width: 600px) {
    font-size: 12px;
  }
`;
const CopyIcon = styled.div`
  position: relative;
  color: white;
  cursor: pointer;
  padding: 0 0 0 15px;
  @media (max-width: 425px) {
    padding: 0 0 0 5px;
  }
`;
const PayButtons = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
`;

const ButtonConfirm = styled.button`
  background: linear-gradient(45deg, #0a5d6e, #00aacd);
  border-radius: 50px;
  outline: none;
  border: none;
  font-size: 24px;
  padding: 20px 80px;
  margin: 40px 0 10px;
  cursor: pointer;
  color: #e9e9e9;
  width: 100%;
  transition: 1s;
  @media (max-width: 768px) {
    margin: 5px 0;
  }
`;
const IconWrapper = styled.div``;
const Icon = styled.img`
  width: 70px;
`;

const NftNameConfirm4 = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding-bottom: 20px;
  padding-top: 50px;
`;

const AmountHead = styled.div`
  font-size: 50px;
  font-weight: 600;
  color: #fff;
  padding-top: 5px;
  text-transform: capitalize;
`;
const AmountSubHead = styled.div`
  font-size: 16px;
  color: #6c6c6c;
  text-transform: capitalize;
`;

const ImageWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  padding-bottom: 10px;
`;
const Image = styled.img`
  width: 12%;
`;
const ToolTipSpan = styled.span`
  width: 80px;
  background-color: #f3eded;
  color: #080808;
  text-align: center;
  border-radius: 6px;
  padding: 5px 0;
  position: absolute;
  z-index: 1;
  bottom: 125%;
  left: 145%;
  margin-left: -60px;
  opacity: 1;
  font-weight: 700;
  transition: opacity 0.3s;
  ::after {
    content: "";
    position: absolute;
    top: 100%;
    left: 50%;
    margin-left: -5px;
    border-width: 5px;
    border-style: solid;
    border-color: #f3eded transparent transparent transparent;
  }
`;
const TransferTokenWrapper = ({
  allContractDetails,
  getInformation,
  mldTokenName,
  maticTokenName,
  lordTokenName,
  getUserBalance,
  usdtTokenName,
  userBalance,
}) => {
  const classes = useStyles();
  const [receiveAddress, setReceiveAddress] = useState("");
  const [amount, setAmount] = useState("");
  const [gasPrice, setGasPrice] = useState(0);
  const [loading, setLoading] = useState(false);
  const [sendLoading, setSendLoading] = useState(false);
  const [showMldPopup, setShowMldPopup] = useState(false);
  const [errorAddress, setErrorAddress] = useState("");
  const [errorAmount, setErrorAmount] = useState("");
  const [proceedOpen, setProceedOpen] = useState(false);
  const [isTransferError, setIsTransferError] = useState(false);
  
  const {userAccInfo, setUserAccInfo}=useContext(userInfoContext)
  // const [isTransferFailed,setIsTransferFailed]=useState(false)
  const [message, setMessage] = useState("");
  const [confirmOpen, setConfirmOpen] = useState(false);
  const [successPopup, setSuccessPopup] = useState(false);
  const [mldToTransfer, setMldToTransfer] = useState("");
  const [maticToTransfer, setMaticToTransfer] = useState("");
  const [lordToTransfer, setLordToTransfer] = useState("");
  const [mldTransHash, setMldTransHash] = useState("");
  const [lordTransHash, setLordTransHash] = useState("");
  const [maticTransHash, setMaticTransHash] = useState("");
  const [open, setOpen] = useState(false);
  const [errorBalance, setErrorBalance] = useState("");
  const [lowBalancePopUp, setLowBalancePopup] = useState(false);
  const [isCopied, setIsCopied] = useState(false);

  //(By Adarsh)
  const [isButtonDisabled, setIsButtonDisabled] = useState(true);

  const calculateGasPrice = (data)=>{
    try{
      let gasLimitHex = data?.gasUsed || data?.effectiveGasPrice?._hex;
      let gasPriceHex = data?.gasPrice || data?.gasUsed?._hex;
      let gasLimitBN = ethers.toBigInt(gasLimitHex);
      let gasPriceBN = ethers.toBigInt(gasPriceHex);
      let totalCostWei = Number(gasLimitBN) *Number(gasPriceBN);
      let totalCostEth = ethers.formatEther(totalCostWei.toString());
      let totalCostDecimal = parseFloat(totalCostEth);
      return totalCostDecimal?totalCostDecimal:0;
    }catch(err){
      return 0;
      console.log("error in calculating gas price");
    }
  }
  const CopyAddress = async () => {
    try {
      if (mldTokenName && mldTransHash) {
        navigator.clipboard.writeText(mldTransHash);
        setIsCopied(true);
        setTimeout(() => {
          setIsCopied(false);
        }, 3000);
      } else if (lordTokenName && lordTransHash) {
        navigator.clipboard.writeText(lordTransHash);
        setIsCopied(true);
        setTimeout(() => {
          setIsCopied(false);
        }, 3000);
      } else if (maticTokenName && maticTransHash) {
        navigator.clipboard.writeText(maticTransHash);
        setIsCopied(true);
        setTimeout(() => {
          setIsCopied(false);
        }, 3000);
      } else if (usdtTokenName && mldTransHash) {
        navigator.clipboard.writeText(mldTransHash);
        setIsCopied(true);
        setTimeout(() => {
          setIsCopied(false);
        }, 3000);
      }
    } catch (error) {
      console.error("Error copying text:", error);
      toast.error("Copy failed");
    }
  };
  const triggerPusher = (receiveAddress) => {
    let config = {
      method: "post",
      maxBodyLength: Infinity,
      url: `${environmentVariables?.apiUrl}/nftmarketplace/api/v1/trigger_event`,
      headers: {authorization:`Bearer ${userAccInfo}`},
      data: { address: receiveAddress.toLowerCase() },
    };

    axios
      .request(config)
      .then((response) => {
        console.log(JSON.stringify(response.data));
      })
      .catch((error) => {
        console.log(error);
      });
  };
  // console.log(userBalance,getUserBalance, "Balance")

  // const web3 = new Web3(
  //   new Web3.providers.WebsocketProvider(
  //     "wss://polygon-mainnet.g.alchemy.com/v2/Pzgd7MQHTSmoAD8nColEHN0xb7B8yKmV"
  //   )
  // );
  // const copyRef = useRef(null);

  const navigation = useNavigate();
  const currentDate = new Date();
  const monthAbbreviation = currentDate.toLocaleString("default", {
    month: "short",
  });

  const day = currentDate.getDate();
  const year = currentDate.getFullYear();
  let hours = currentDate.getHours();
  const minutes = currentDate.getMinutes();
  const ampm = hours >= 12 ? "PM" : "AM";

  if (hours > 12) {
    hours -= 12;
  }

  const formattedMinutes = String(minutes).padStart(2, "0");
  const formattedDateTime = `${monthAbbreviation} ${day} ${year}, ${hours}:${formattedMinutes} ${ampm}`;

  const balance = {
    USDT:userBalance?.USDT|| parseInt(allContractDetails?.usdtBal) / 1000000 ,
    MLD:userBalance?.MLDBalanceDec|| parseInt(allContractDetails?.mldBal) / 1000000000000000000,
    MATIC:userBalance?.MATIC|| parseInt(allContractDetails?.maticBal) / 1000000000000000000,
    //(By Adarsh)
    LORD: userBalance?.LORD||(allContractDetails?.lordBal) / 1000000000000000000
  };
  const sendTokenTransferData = (from, to, amount, currency, trxHash, trxFees) => {
    let data = JSON.stringify({
      from: from,
      to: to,
      trxHash: trxHash,
      trxFees: trxFees,
      amount: amount,
      currency: currency,
    });

    let config = {
      method: "post",
      maxBodyLength: Infinity,
      url: `${environmentVariables?.apiUrl}/nftmarketplace/api/v1/savetransfertokendata`,
      headers: {
        "Content-Type": "application/json",
      },
      data: data,
    };

    axios
      .request(config)
      .then((response) => {
        // console.log(JSON.stringify(response.data));
      })
      .catch((error) => {
        console.log(error);
      });
  };
  const mldSend = async () => {
    try {
      if (parseFloat(amount) > parseFloat(userBalance?.MLDBalanceDec)) {
        setMessage("Not enough $MLD");
        setIsTransferError(true);
        setLoading(false);
        return;
      } else {
        setLoading(true);
        const sendAmount = ethers.parseEther(amount.toString());
        await sendToken(
          allContractDetails?.provider,
          allContractDetails?.mldTokenContract,
          receiveAddress,
          sendAmount
        )
          .then(async (data) => {
            if (data !== null) {
              // console.log(data, "data after mld send");
              // socket.emit("send_mld", {
              //   receiveAddress,
              //   amount,
              //   currency: "MLD",
              //   from: data?.from,
              // });
              const gasPrice = calculateGasPrice(data)
              triggerPusher(receiveAddress);
              sendTokenTransferData(
                allContractDetails?.address,
                receiveAddress,
                amount,
                "$MLD",
                data?.transactionHash||data?.hash,
                gasPrice
              );

              setLoading(false);
              setShowMldPopup(true);
              setSuccessPopup(true);
              setReceiveAddress("");
              // setAmount("");
              setMldToTransfer(data.from);
              setMldTransHash(data?.transactionHash||data?.hash);
              console.log(data, "dataofsendingmld");
              setProceedOpen(false);
              getUserBalance(allContractDetails?.address);
            }
          })
          .catch((err) => {
            setLoading(false);
            setMessage(err?.response?.data?.message || err?.message||"Transaction Failed");
            setIsTransferError(true);
          });
      }
    } catch (err) {
      console.log("err inside a mld", err);
    }
  };

  const lordSend = async () => {
    try {
      if (parseFloat(amount) > parseFloat(userBalance?.LORD)) {
        setMessage("not enough Lords");
        setIsTransferError(true);
        return;
      } else {
        setLoading(true);

        const sendAmount = ethers.parseEther(amount.toString());
        await sendToken(
          allContractDetails?.provider,
          allContractDetails?.lordTokenContract,
          receiveAddress,
          sendAmount
        )
          .then(async (data) => {
            if (data !== null) {
              // socket.emit("send_lord", {
              //   receiveAddress,
              //   amount,
              //   currency: "Lord",
              //   from: data?.from,
              // });
              triggerPusher(receiveAddress);
              getUserBalance(allContractDetails?.address);
              const gasPrice = calculateGasPrice(data)
              sendTokenTransferData(
                allContractDetails?.address,
                receiveAddress,
                amount,
                "Lord",
                data?.transactionHash||data?.hash,
                gasPrice
              );

              setLoading(false);
              setShowMldPopup(true);
              setSuccessPopup(true);
              setReceiveAddress("");
              // setAmount("");
              setLordToTransfer(data.from);
              setLordTransHash(data?.transactionHash||data?.hash);
              setProceedOpen(false);
            }
          })
          .catch((err) => {
            setLoading(false);
            setMessage(err?.response?.data?.message || err?.message||"Transaction Failed");
            setIsTransferError(true);
          });
      }
    } catch (err) {
      console.log("err inside a lord", err);
      setMessage(err?.response?.data?.message || err?.message||"Transaction Failed");
      setIsTransferError(true);
    }
  };

  const usdtSend = async () => {
    try {
      if (parseFloat(amount) > parseFloat(balance?.USDT)) {
        setMessage("not enough USDT");
        setIsTransferError(true);
        return;
      } else {
        setLoading(true);
        const sendAmount = ethers.parseUnits(amount.toString(), 6);

        await sendToken( 
          allContractDetails?.provider,
          allContractDetails?.usdtTokenContract,
          receiveAddress,
          sendAmount
        )
          .then(async (data) => {
            console.log(data, "datawhensendingusdt");
            if (data !== null) {
              // socket.emit("send_usdt", {
              //   receiveAddress,
              //   amount,
              //   currency: "USDT",
              //   from: data?.from,
              // });
              triggerPusher(receiveAddress);
              getUserBalance(allContractDetails?.address);
              const gasPrice = calculateGasPrice(data)
              sendTokenTransferData(
                allContractDetails?.address,
                receiveAddress,
                amount,
                "USDT",
                data?.transactionHash||data?.hash,
                gasPrice
              );

              // console.log(data, "data after usdt send");
              setLoading(false);
              setShowMldPopup(true);
              setSuccessPopup(true);
              setReceiveAddress("");
              setMldToTransfer(data.from);
              setMldTransHash(data?.transactionHash||data?.hash);
              setProceedOpen(false);
              // setAmount("");
            }
          })
          .catch((err) => {
            setLoading(false);
          });
      }
    } catch (err) {
      console.log("err inside usdt", err);
      setMessage(err?.response?.data?.message || err?.message||"Transaction Failed");
      setIsTransferError(true);
    }
  };

  const maticSend = async () => {
    try {
      if (parseFloat(amount) > parseFloat(userBalance?.MATIC)) {
        setMessage("not enough POL");
        setIsTransferError(true);
        return;
      } else {
        setLoading(true);

        const sendAmount = ethers.parseEther(amount.toString());
        // console.log("sendAmount", sendAmount);
        await maticSendToken(allContractDetails?.signer, {
          to: receiveAddress,
          value: sendAmount,
        })
          .then(async (data) => {
            if (data !== null) {
              // socket.emit("send_matic", {
              //   receiveAddress,
              //   amount,
              //   currency: "Matic",
              //   from: data?.from,
              // });
              triggerPusher(receiveAddress);
              getUserBalance(allContractDetails?.address);
              const gasPrice = calculateGasPrice(data)
              sendTokenTransferData(
                allContractDetails?.address,
                receiveAddress,
                amount,
                "POL",
                data?.transactionHash || data?.hash,
                gasPrice
              );

              setLoading(false);
              setShowMldPopup(true);
              setSuccessPopup(true);
              setReceiveAddress("");
              // setAmount("");
              setMaticToTransfer(data.from);
              setMaticTransHash(data?.transactionHash || data?.hash);
              setProceedOpen(false);
            }
          })
          .catch((err) => {
            setLoading(false);
            setMessage(err?.response?.data?.message || err?.message||"Transaction Failed");
            setIsTransferError(true);
          });
      }
    } catch (err) {
      console.log("err inside a pol", err);
    }
  };
  const getCurrencyName = () => {
    let currencyName = null;
    if (mldTokenName) {
      currencyName = "MLD";
    } else if (maticTokenName) {
      currencyName = "POL";
    } else if (lordTokenName) {
      currencyName = "LORD";
    } else if (usdtTokenName) {
      currencyName = "USDT";
    }
    return currencyName;
  };

  const handleSend = async () => {
    try {
      setSendLoading(true);
      let currencyName = getCurrencyName();
      const balanceAmount = balance[currencyName];
      const enteredAmount = parseFloat(amount);

      if (enteredAmount > balanceAmount) {
        setErrorAmount("Amount exceeds your balance");
        setSendLoading(false);
        return;
      }
      if (currencyName === "POL") {
        let gas = await gasEstimateMaticTransfer(
          amount,
          receiveAddress,
          allContractDetails?.address
        );
        if (gas == null || gas == undefined) {
          gas = 0.03;
        }
        if (parseFloat(enteredAmount) + 0.03 > parseFloat(userBalance?.MATIC)) {
          // setOpen(true);
          // setLowBalancePopup(true);
          setMessage("Insufficient POL for gas fee");
          setIsTransferError(true);
        } else if (validateAmount()) {
          setProceedOpen(true);
          setGasPrice(gas);
          setSendLoading(true);
        }
      } else {
        let sendAmount;
        if (currencyName == "USDT") {
          sendAmount = ethers.parseUnits(amount.toString(), 6);
        } else {
          sendAmount = ethers.parseUnits(amount.toString(), 18);
        }
        const gas = await gasEstimate(
          allContractDetails,
          receiveAddress,
          sendAmount,
          currencyName
        );
        if (gas > userBalance?.MATIC) {
          // setOpen(true);
          setMessage("Insufficient POL for gas fee");
          setIsTransferError(true);
        } else if (validateAmount()) {
          setProceedOpen(true);
          setGasPrice(gas);
          setSendLoading(true);
        }
      }
      setSendLoading(false);
    } catch (err) {
      console.log(err);
    }
  };

  // const handleSend = async () => {
  //   setProceedOpen(true);
  //   let currencyName = getCurrencyName();
  //   if (currencyName == "MATIC") {
  //     const gas = await gasEstimateMaticTransfer(
  //       amount,
  //       receiveAddress,
  //       allContractDetails?.address
  //     );

  //     setGasPrice(gas);
  //   } else {
  //     const sendAmount = ethers.parseEther(amount.toString());
  //     const gas = await gasEstimate(
  //       allContractDetails,
  //       receiveAddress,
  //       sendAmount,
  //       currencyName
  //     );
  //     setGasPrice(gas);
  //   }
  // };
  const sendTransaction = async () => {
    setLoading(true);

    if (mldTokenName) {
      await mldSend();
    }
    if (lordTokenName) {
      await lordSend();
    }
    if (maticTokenName) {
      if (amount > balance["MATIC"]) {
        // alert("Not enough balance");
        toast.warning("not enough balance")
        // setLoading(false);
        return;
      } 
      // else {
      //   let sendAmount = ethers.parseEther(amount.toString());
        // const gas = gasEstimateMatic(allContractDetails, {
        //   to: receiveAddress,
        //   value: sendAmount,
        // });
        // console.log(gas, "matic gas price");
      // }
      await maticSend();
    }
    if (usdtTokenName) {
      await usdtSend();
    }
  };

  const explorerHandler = () => {
    let explorerUrl = "";

    if (mldTokenName && mldTransHash) {
      explorerUrl = `https://polygonscan.com/tx/${mldTransHash}`;
    } else if (lordTokenName && lordTransHash) {
      explorerUrl = `https://polygonscan.com/tx/${lordTransHash}`;
    } else if (maticTokenName && maticTransHash) {
      explorerUrl = `https://polygonscan.com/tx/${maticTransHash}`;
    } else if (usdtTokenName && mldTransHash) {
      explorerUrl = `https://polygonscan.com/tx/${mldTransHash}`;
    }

    if (explorerUrl) {
      window.open(explorerUrl, "_blank");
    } else {
      console.error("Invalid token name or transaction hash");
    }
  };

  const withdrawPopup = async () => {
    setShowMldPopup(false);
    await getInformation(allContractDetails);
  };

  const getPlaceholderText = () => {
    if (mldTokenName) {
      return "MLD";
    } else if (maticTokenName) {
      return "POL";
    } else if (lordTokenName) {
      return "LORD";
    } else if (usdtTokenName) {
      return "USDT";
    } else {
      return "Amount";
    }
  };

  const ButtonDisable = () => {
    return (
      receiveAddress.trim() !== "" &&
      ethereumAddressRegex.test(receiveAddress) &&
      amount.trim() !== "" &&
      amount !== "0" &&
      amount !== "0."
    );
  };

  const validateAmount = () => {
    const currencyName = getCurrencyName();
    const balanceAmount = balance[currencyName];
    const inputAmount = parseFloat(amount);
    console.log(balanceAmount, inputAmount, "balanceAmountbalanceAmount");

    if (inputAmount > balanceAmount) {
      setErrorBalance("Amount exceeds your balance");
      return false;
    } else {
      setErrorBalance("");
      return true;
    }
  };

// function for popup validation by arun 
function formatAmount(amount) {
  return parseFloat(amount).toString().replace(/(\.\d{4})\d+/, '$1...');
}

  return (
    <Root>
      <DialogStyledUpdate
        open={isTransferError}
        onClose={() => setIsTransferError(false)}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        PaperProps={{
          sx: { overflow: "initial", backgroundColor: "transparent" },
        }}
      >
        <ButtonCancel onClick={() => setIsTransferError(false)} color="primary">
          X
        </ButtonCancel>
        <div className={classes.customButton}>
          {/* <DialogTitle id="alert-dialog-title"  style={{textAlign:"left", fontSize:"28px", fontWeight:"500", padding:"0"}}>
              Insufficient Balance 
              </DialogTitle> */}

          <NftNameConfirm>
            <NftNameConfirmHead>{message}</NftNameConfirmHead>
          </NftNameConfirm>

          {/* <NftAmountConfirmHeadPur>
                <NftAmountConfirmHead2>Transaction Fee :</NftAmountConfirmHead2>
                <NftAmountConfirmSubHead2>0.015 Matic</NftAmountConfirmSubHead2>
              </NftAmountConfirmHeadPur> */}
          {/* <DialogActions>
                <PayButtons>
                  
                  <ButtonConfirm onClick={handlePurchase} color="primary" autoFocus>
                    Confirm
                  </ButtonConfirm>
                </PayButtons>
              </DialogActions> */}
        </div>
      </DialogStyledUpdate>
      <DialogStyledUpdate
        open={lowBalancePopUp}
        onClose={() => setLowBalancePopup(false)}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        PaperProps={{
          sx: { overflow: "initial", backgroundColor: "transparent" },
        }}
      >
        <ButtonCancel onClick={() => setLowBalancePopup(false)} color="primary">
          X
        </ButtonCancel>
        <div className={classes.customButton}>
          {/* <DialogTitle id="alert-dialog-title"  style={{textAlign:"left", fontSize:"28px", fontWeight:"500", padding:"0"}}>
              Insufficient Balance 
              </DialogTitle> */}
          <NftNameConfirm>
            <NftNameConfirmHead GasFeeText>
              {" "}
              Gas Fee is Greater then your POL Amount
            </NftNameConfirmHead>
          </NftNameConfirm>
        </div>
      </DialogStyledUpdate>
      <Container>
      <Fortwoinputslandscape>
        <AddressWrapper>
          <TextWrapper>
            <Text>Recipient Address</Text>
          </TextWrapper>
          <InputWrapper>
            <input
              style={{
                width: "100%",
                fontSize: "24px",
                background: "rgba(40,43,47,.8)",
                outline: "none",
                border: "none",
                fontWeight: "400",
                textAlign: "left",
                color: "#efefef",
                lineHeight: "16px",
                padding: "15px 15px",
                borderRadius: "10px",
                border: "none",
              }}
              placeholder="Enter Address (0X123...)"
             
              onChange={(e) => {
                setReceiveAddress(e.target.value);
                if (
                  !e.target.value ||
                  e.target.value.length !== 42 ||
                  !e.target.value.startsWith("0x")
                ) {
                  setErrorAddress("Invalid recipient address");
                } else {
                  setErrorAddress("");
                }
              }}
              value={receiveAddress}
            />
          </InputWrapper>
          <ErrorMsg>{errorAddress}</ErrorMsg>
        </AddressWrapper>

        <AddressWrapper>
          <TextWrapper>
            <Text> Amount </Text>
          </TextWrapper>

          <InputWrapper>
            {/* <Input type="number" onChange={(e) => {
            setAmount(e.target.value)
          }} value={receiveAddress} > */}
            <input
              style={{
                width: "100%",
                fontSize: "24px",
                background: "rgba(40,43,47,.8)",
                outline: "none",
                border: "none",
                fontWeight: "400",
                textAlign: "left",
                color: "#efefef",
                lineHeight: "16px",
                padding: "15px 15px",
                borderRadius: "10px",
                border: "none",
              }}
              type="number"
              placeholder={0}
              //changes in onChange function for formatting related issues (By Adarsh)
              onKeyDown={(e)=>{
                if (e.key == "-") { 
                  e.preventDefault();
                }else if(e.key=="+"){
                  e.preventDefault();
                }
              }}
              onChange={(e) => {
                const inputValue = e.target.value;
                // setAmount(inputValue);

                // Regex for valid number inputs
                // const isValidNumber = /^(0|0\.\d+|\d+(\.\d*)?|\.\d+)$/.test(inputValue);

                // if (isValidNumber) {
                //   const numericValue = parseFloat(inputValue); 

                //   if (numericValue > 0) {
                //     setErrorAmount(""); 
                //     setIsButtonDisabled(false); 
                //   } else {
                //     setErrorAmount("Amount must be greater than 0");
                //     setIsButtonDisabled(true); 
                //   }
                // } else {
                //   setAmount("");
                //   setErrorAmount("Please enter a valid number");
                //   setIsButtonDisabled(true);
                // }
                const value = e.target.value;
                      const regex = /^\d{0,10}(\.\d{0,4})?$/;
                      if(regex.test(value)){
                        if (parseFloat(value) > 0) {
                          setAmount(value);
                          setIsButtonDisabled(false)
                          setErrorAmount("")
                        } else {
                          setErrorAmount("Amount must be greater than 0")
                          setIsButtonDisabled(true)
                          e.preventDefault();
                        }
                        
                        const inputValue = e.target.value;
                        const sanitizedValue = inputValue.replace(/^-/, "");
                        setAmount(sanitizedValue);
                      }else{
                        // setErrorAmount("Please enter a valid number")
                        setIsButtonDisabled(true)
                      }
              }}
              // onChange={(e) => {
              //   const inputValue = e.target.value;
              //   setAmount(inputValue);
              //   setErrorAmount("");

              //   if (/^(0|0\.\d+|\d+(\.\d*)?|\.\d+)$/.test(inputValue)) {
              //     if (validateAmount()) {
              //       setErrorBalance("");
              //     }
              //   } else {
              //     setAmount("");
              //     setErrorAmount("Please enter a valid number");
              //   }
              // }}
              ////////////////////////
              // onChange={(e) => {
              //   setAmount(e.target.value);
              //   const inputValue = e.target.value;
              //    setAmount(inputValue);
              //     setErrorAmount("");
              //     if (/^(0|0\.\d+|\d+(\.\d*)?|\.\d+)$/.test(inputValue)) {
              //       setAmount(inputValue);
              //       setErrorAmount("");
              //     } else {
              //       setAmount("");
              //       setErrorAmount("Please enter a valid number");
              //     }
              //   }}

              ///////////////////////
              //   if (
              //     /^\d+(\.\d+)?$/.test(inputValue) &&
              //     parseFloat(inputValue) > 0
              //   ) {
              //     setAmount(inputValue);
              //     setErrorAmount("");
              //   } else {
              //     setAmount("");
              //     setErrorAmount("Please enter a valid amount");
              //   }
              // }}
              value={amount}
            />
            <div style={{ position: "absolute", top: "15px", right: "15px" }}>
              {mldTokenName && "$MLD"}
              {maticTokenName && "POL"}
              {lordTokenName && "$LORD"}
              {usdtTokenName && "USDT (POL)"}
            </div>
          </InputWrapper>
          <ErrorMsg>{errorAmount} </ErrorMsg>
        </AddressWrapper>
      </Fortwoinputslandscape>

        {/* <FeeTextWrapper>
          <FeeText>Fees</FeeText>
          <FeeText>1 MLD</FeeText>
        </FeeTextWrapper>

        <FeeTextWrapper>
          <FeeText>Amount Received</FeeText>
          <FeeText>0 MLD</FeeText>
        </FeeTextWrapper> */}

        <ButtonWrapper>
          {/* <Button onClick={sendTransaction}>Send</Button> */}

          <Button onClick={handleSend} disabled={isButtonDisabled}>
            {sendLoading ? (
              <div
                style={{
                  marginTop: "0px",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                }}
              >
                {" "}
                <CircularLoader></CircularLoader>
              </div>
            ) : (
              "Send"
            )}
            {/* Send */}
          </Button>
        </ButtonWrapper>
      </Container>
      {showMldPopup && (
        <DialogStyledUpdate
          open={successPopup}
          onClose={() =>{ setSuccessPopup(false);setAmount("");}}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
          PaperProps={{
            sx: { overflow: "initial", backgroundColor: "transparent" },
          }}
        >
          <ButtonCancel
            onClick={() => {
              setSuccessPopup(false);
              setSendLoading(false);
              setAmount("")
            }}
            color="primary"
          >
            X
          </ButtonCancel>
          <div className={classes.customButton}>
            <div>
              <ImageWrapper>
                <Image src={SuccessIcon} />
              </ImageWrapper>

              <DialogTitle
                id="alert-dialog-title"
                style={{
                  textAlign: "center",
                  fontSize: "36px",
                  fontWeight: "500",
                  padding: "0",
                  color: "#fff",
                }}
              >
                Transaction Successful
              </DialogTitle>
              <div
                style={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  textAlign: "center",
                }}
              >
                <div
                  style={{
                    fontSize: "18px",
                    cursor: "pointer",
                    color: "#cd2222",
                    textTransform: "capitalize",
                  }}
                  onClick={explorerHandler}
                >
                  view on explorer{" "}
                  <span>
                    <i class="fa-solid fa-arrow-up-right-dots"></i>
                  </span>
                </div>
              </div>
            </div>
            <DialogContent style={{ padding: "0 0 40px" }}>
              {/* <DialogContentText
                  id="alert-dialog-description"
                  style={{
                    textAlign: "left",
                    color: "#bbb",
                    fontSize: "16px",
                  }}
                >
                  Please verify this information to complete the transaction
                </DialogContentText> */}
            </DialogContent>
            {/* <NftNameConfirm>
              
                <NameandcategoriesWrapper>
                  <NftNameConfirmHead>
                  {`${
          mldTokenName !== undefined ? "MLD" : ""
        }`} {`${lordTokenName !== undefined ? "LORD" : ""}`} {`${
          maticTokenName !== undefined ? "MATIC" : ""
        }`}  Transfer 
                  </NftNameConfirmHead>
                  <NftNameConfirmSubHead>
               
                  </NftNameConfirmSubHead>
                </NameandcategoriesWrapper>
                <NftNameConfirmHead>
                  {amount} {`${
          mldTokenName !== undefined ? "MLD" : ""
        }`} {`${lordTokenName !== undefined ? "LORD" : ""}`} {`${
          maticTokenName !== undefined ? "MATIC" : ""
        }`} 
                </NftNameConfirmHead>
              </NftNameConfirm> */}
            {/* <NftAmountConfirm>
                <NftAmountConfirmHead>To :</NftAmountConfirmHead>
                <NftAmountConfirmSubHead>
                 
                  2342
                </NftAmountConfirmSubHead>
              </NftAmountConfirm> */}

            <NftAmountConfirmHeadPur>
              <NftAmountConfirmHead2>Transaction Hash:</NftAmountConfirmHead2>
              <NftAmountConfirmSubHead2>
                {mldTokenName && mldTransHash
                  ? `${mldTransHash.slice(0, 10)} ..... ${mldTransHash.slice(
                      -10
                    )}`
                  : ""}
                {usdtTokenName && mldTransHash
                  ? `${mldTransHash.slice(0, 10)} ..... ${mldTransHash.slice(
                      -10
                    )}`
                  : ""}
                {lordTokenName && lordTransHash
                  ? `${lordTransHash.slice(0, 10)} ..... ${lordTransHash.slice(
                      -10
                    )}`
                  : ""}
                {maticTokenName && maticTransHash
                  ? `${maticTransHash.slice(
                      0,
                      10
                    )} ..... ${maticTransHash.slice(-10)}`
                  : ""}
                <CopyIcon onClick={CopyAddress}>
                  <i class="fa-solid fa-copy"></i>
                  {isCopied && <ToolTipSpan>Copied</ToolTipSpan>}
                </CopyIcon>
              </NftAmountConfirmSubHead2>
            </NftAmountConfirmHeadPur>
            <NftAmountConfirmHeadPur>
              <NftAmountConfirmHead2>Transaction Fee :</NftAmountConfirmHead2>
              <NftAmountConfirmSubHead2>
                {`${gasPrice?.toFixed(6)} POL`}
              </NftAmountConfirmSubHead2>
            </NftAmountConfirmHeadPur>
            <DialogActions>
              <NftNameConfirm4>
                <NftNameConfirmSubHead> Amount </NftNameConfirmSubHead>
                <AmountHead>
                    
                {formatAmount(amount||0)} {`${mldTokenName !== undefined ? "$MLD" : ""}`}{" "}
                  {`${lordTokenName !== undefined ? "$LORD" : ""}`}{" "}
                  {`${maticTokenName !== undefined ? "POL" : ""}`}
                  {`${usdtTokenName !== undefined ? "USDT (POL)" : ""}`}
                </AmountHead>
                <AmountSubHead>{formattedDateTime}</AmountSubHead>
              </NftNameConfirm4>
            </DialogActions>
          </div>
        </DialogStyledUpdate>
        // <ConnectWalletPopup
        //   showPopup={showMldPopup}
        //   setShowPopup={setShowMldPopup}
        //   onClickFun={withdrawPopup}
        //   text={`Congratulation you Send ${`${
        //     mldTokenName !== undefined ? "MLD" : ""
        //   }`} ${`${lordTokenName !== undefined ? "LORD" : ""}`} ${`${
        //     maticTokenName !== undefined ? "MATIC" : ""
        //   }`} successfully.`}
        // ></ConnectWalletPopup>
      )}
      <DialogStyledUpdate
        open={proceedOpen}
        onClose={() => setProceedOpen(false)}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        PaperProps={{
          sx: { overflow: "initial", backgroundColor: "transparent" },
        }}
      >
        <ButtonCancel onClick={() => setProceedOpen(false)} color="primary">
          X
        </ButtonCancel>
        <div className={classes.customButton}>
          <DialogTitle
            id="alert-dialog-title"
            style={{
              textAlign: "left",
              fontSize: "28px",
              fontWeight: "500",
              padding: "0",
            }}
          >
            Transfer {`${mldTokenName !== undefined ? "$MLD" : ""}`}{" "}
            {`${lordTokenName !== undefined ? "$LORD" : ""}`}{" "}
            {`${maticTokenName !== undefined ? "POL" : ""}`}
            {`${usdtTokenName !== undefined ? "USDT (POL)" : ""}`}
          </DialogTitle>
          <DialogContent style={{ padding: "0 0 40px" }}>
            <DialogContentText
              id="alert-dialog-description"
              style={{
                textAlign: "left",
                color: "#bbb",
                fontSize: "16px",
              }}
            >
              Please verify this information to complete the transaction
            </DialogContentText>
          </DialogContent>
          <NftNameConfirm>
            <NameandcategoriesWrapper>
              <NftNameConfirmHead>
                {/* {`${mldTokenName !== undefined ? "MLD" : ""}`}{" "}
                {`${lordTokenName !== undefined ? "LORD" : ""}`}{" "}
                {`${maticTokenName !== undefined ? "MATIC" : ""}`}
                {`${usdtTokenName !== undefined ? "USDT" : ""}`}  */}
                Amount
              </NftNameConfirmHead>
              <NftNameConfirmSubHead>{/* qweqweqwe */}</NftNameConfirmSubHead>
            </NameandcategoriesWrapper>
            <NftNameConfirmHead>
            {formatAmount(amount)} {`${mldTokenName !== undefined ? "$MLD" : ""}`}{" "}
              {`${lordTokenName !== undefined ? "$LORD" : ""}`}{" "}
              {`${maticTokenName !== undefined ? "POL" : ""}`}{" "}
              {`${usdtTokenName !== undefined ? "USDT (POL)" : ""}`}
              {console.log("amount")}
            </NftNameConfirmHead>
          </NftNameConfirm>
          {/* <NftAmountConfirm>
                  <NftAmountConfirmHead>To :</NftAmountConfirmHead>
                  <NftAmountConfirmSubHead>
                   
                    2342
                  </NftAmountConfirmSubHead>
                </NftAmountConfirm> */}
          <NftAmountConfirmHeadPur>
            <NftAmountConfirmHead2>To</NftAmountConfirmHead2>
            <NftAmountConfirmSubHead2>
              {/* {` ${receiveAddress.slice(0,6)}`}.......{`${receiveAddress.slice(-6)}`} */}
              {` ${receiveAddress}`}
            </NftAmountConfirmSubHead2>
          </NftAmountConfirmHeadPur>
          <NftAmountConfirmHeadPur>
            <NftAmountConfirmHead2>From</NftAmountConfirmHead2>
            <NftAmountConfirmSubHead2>
              {allContractDetails?.address}
              {/* {` ${allContractDetails?.address.slice(0,6)}`}.......{`${allContractDetails?.address.slice(-6)}`} */}
              {/* {mldToTransfer ? mldToTransfer : maticToTransfer ? maticToTransfer : lordToTransfer} */}
            </NftAmountConfirmSubHead2>
          </NftAmountConfirmHeadPur>
          <NftAmountConfirmHeadPur>
            <NftAmountConfirmHead2>Transaction Fee :</NftAmountConfirmHead2>
            <NftAmountConfirmSubHead2>
              {`${gasPrice?.toFixed(8)} POL`}
            </NftAmountConfirmSubHead2>
          </NftAmountConfirmHeadPur>
          <DialogActions>
            <PayButtons>
              <ButtonConfirm
                color="primary"
                autoFocus
                onClick={sendTransaction}
              >
                {loading ? (
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                    }}
                  >
                    {" "}
                    <CircularLoader />{" "}
                  </div>
                ) : (
                  `Confirm`
                )}
              </ButtonConfirm>
            </PayButtons>
          </DialogActions>
        </div>
      </DialogStyledUpdate>
    </Root>
  );
};

export default TransferTokenWrapper;
